import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Box, FormControl, InputLabel, Select, MenuItem, CircularProgress, Typography } from '@mui/material';

const UserFormModal = ({ isOpen, onClose, onSave, user }) => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('Servis Teknisyeni');
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');

  const availableRoles = ['Yönetici', 'Ofis Personeli', 'Servis Teknisyeni'];

  useEffect(() => {
    if (user) {
      setUsername(user.username || '');
      setEmail(user.email || '');
      setRole(user.role || 'Servis Teknisyeni');
      setPassword(''); // Şifre düzenlemede boş gelir, sadece değişirse gönderilir
    } else {
      setUsername('');
      setEmail('');
      setRole('Servis Teknisyeni');
      setPassword('');
    }
    setError('');
  }, [user, isOpen]);

  const handleSave = async () => {
    setError('');
    // Validasyon
    if (!username || !email || !role) {
      setError('Kullanıcı adı, e-posta ve rol alanları zorunludur.');
      return;
    }
    // Yeni kullanıcı eklerken şifre zorunlu
    if (!user && !password) {
      setError('Yeni kullanıcı için şifre zorunludur.');
      return;
    }
    // Şifre girilmişse uzunluk kontrolü
    if (password && password.length < 6) {
      setError('Şifre en az 6 karakter olmalıdır.');
      return;
    }

    setIsSaving(true);
    try {
      const userData = { username, email, role };
      if (password) {
        userData.password = password;
      }
      if (user) {
        userData.userId = user.id; // Düzenleme için ID ekle
      }

      await onSave(userData);
      onClose();
    } catch (err) {
      console.error("Kullanıcı kaydetme hatası:", err);
      setError(err.message || 'Bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setIsSaving(false);
    }
  };

  const handleClose = () => {
    setError('');
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{user ? 'Kullanıcı Düzenle' : 'Yeni Kullanıcı Ekle'}</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate autoComplete="off" sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            label="Kullanıcı Adı"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            fullWidth
            required
            autoFocus
          />
          <TextField
            label="E-posta Adresi"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            required
          />
          <TextField
            label={user ? "Yeni Şifre (Değiştirmek istemiyorsanız boş bırakın)" : "Şifre"}
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            required={!user}
            helperText={!user ? "Şifre en az 6 karakter olmalıdır." : ""}
          />
          <FormControl fullWidth required>
            <InputLabel id="role-select-label">Rol</InputLabel>
            <Select
              labelId="role-select-label"
              value={role}
              label="Rol"
              onChange={(e) => setRole(e.target.value)}
            >
              {availableRoles.map(r => (
                <MenuItem key={r} value={r}>{r}</MenuItem>
              ))}
            </Select>
          </FormControl>
          {error && <Typography color="error" sx={{ mt: 1 }}>{error}</Typography>}
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: '16px 24px' }}>
        <Button onClick={handleClose} disabled={isSaving}>İptal</Button>
        <Button onClick={handleSave} variant="contained" disabled={isSaving}>
          {isSaving ? <CircularProgress size={24} /> : (user ? 'Güncelle' : 'Kullanıcıyı Kaydet')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserFormModal;